<div class="suggestions">
    <h1 class="suggestions-title">Suggestions:</h1>
    <span
        *ngFor="let suggestion of suggestions"
        (click)="onSuggestionClick(suggestion)"
        class="suggestion-item"
    >
        {{ suggestion[displayValue] }}
    </span>
</div>
